var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { FileDownloadType } from "@/share/FileRequest";
import { action, makeObservable, observable } from "mobx";
import { VersionDialogState } from "@/app/UIComponents/VersionDialog";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { DraftType } from "@@/Draft";
import { AdminMiniPdfViewerState } from "../UIComponents/AdminMiniPDFViewer";
import { PdfPageStore } from "@/app/UIComponents/PdfPagestore";
export var VirtuStatus;
(function (VirtuStatus) {
    VirtuStatus[VirtuStatus["Postive"] = 0] = "Postive";
    VirtuStatus[VirtuStatus["Negative"] = 1] = "Negative";
    VirtuStatus[VirtuStatus["Unknown"] = 2] = "Unknown";
})(VirtuStatus || (VirtuStatus = {}));
export class AdminDocumentDetailStore {
    constructor() {
        this.downloading = false;
        this.show = false;
        this.title = "Document Details";
        this.loading = false;
        this.isViewable = false;
        this.hasVirus = VirtuStatus.Unknown;
        this.isexcel = false;
        this.hasviewercontent = false;
        this.loadingexcelcontent = false;
        this.pdfpagesdetails = [];
        this.isDownloadable = false;
        this.downloadProgress = 0;
        this.downloaderror = false;
        this.downloadpath = "";
        this.fetchingstatus = false;
        this.showvirustitle = false;
        this.loadpdfinfo = false;
        this.inqueue = false;
        this.keywords = [];
        this.summary = "";
        this.size = 0;
        this.waitingforpath = false;
        this.versionState = new VersionDialogState();
        this.editable = false;
        this.creatingdraft = false;
        this.menuopen = false;
        this.hassummary = false;
        this.haskeyword = false;
        this.showsummary = false;
        this.showkeywords = false;
        this.gettingkeywords = false;
        this.gettingsummary = false;
        this.queued = false;
        this.canedit = false;
        this.orgname = "";
        this.activeDocumentId = "";
        this.activeuserid = "";
        this.showcomments = false;
        this.shownotespanel = true;
        makeObservable(this);
        APPEvent.addSubscriberForAdminPdfFilePage((res) => {
            var _a;
            if (this.loadingexcelcontent && res.id === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) &&
                res.pagename === 'viewer' && res.userid === this.activeuserid) {
                let page = "";
                if (res.page !== undefined) {
                    page = LetrwingCrypto.fromBase64ToUTF8(LetrwingCrypto.fromBase64ToUTF8(res.page));
                }
                APPEvent.publishAdminSpreadsheetCon({
                    content: page,
                    readonly: true,
                    floating: res.ischooser,
                    userid: res.userid
                });
                this.setLoadingExcelContent(false);
            }
        });
        APPEvent.addSubscriberForAdminDownload((res) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (res.id === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) &&
                res.letrid === this.info.letrid && res.userid === this.activeuserid) {
                if (res.requesttype === FileDownloadType.Metadata) {
                    this.setDownloadable((_c = (_b = res.info) === null || _b === void 0 ? void 0 : _b.isDownloadable) !== null && _c !== void 0 ? _c : false);
                    if (res.info !== undefined && res.info.ingestunboxed !== undefined) {
                        this.pdfpagesdetails = res.info.ingestunboxed.detail;
                        if (this.canedit) {
                            this.setHasViewerContent(res.info.ingestunboxed.hasviewer);
                        }
                        else {
                            this.setHasViewerContent(false);
                        }
                        if (!res.info.ingestunboxed.haspdf &&
                            res.info.ingestunboxed.hasviewer && res.info.ingestunboxed.isExcel) {
                            this.loadExcelContent();
                            this.setIsExcel(true);
                        }
                        else {
                            this.setViewable(res.info.ingestunboxed.haspdf);
                            this.setIsExcel(false);
                        }
                        // if (res.info.ingestunboxed.hassummary) {
                        //     this.setHasSummary(true);
                        //     this.checkAndGetSummary();
                        // } else {
                        //     this.setHasSummary(false);
                        // }
                        // if (res.info.ingestunboxed.haskeyword) {
                        //     this.setHasKeyword(true);
                        //     this.checkAndGetKeyWords();
                        // } else {
                        //     this.setHasKeyword(false);
                        // }
                        this.checkAndGetFindDict();
                        this.setHasVirus(res.info.ingestunboxed.hasvirus ?
                            VirtuStatus.Negative : VirtuStatus.Postive);
                        AdminMiniPdfViewerState.setActiveUserId(this.activeuserid);
                        AdminMiniPdfViewerState.setPdfPageDetails(this.pdfpagesdetails);
                    }
                    else {
                        this.setViewable(false);
                        this.setHasVirus(VirtuStatus.Unknown);
                        // lets also do some more things
                        AdminMiniPdfViewerState.setPdfPageDetails([]);
                        this.setHasViewerContent(false);
                        this.setQueued(true);
                    }
                    AdminMiniPdfViewerState.setActiveFileKey((_e = (_d = this.info) === null || _d === void 0 ? void 0 : _d.accesskey) !== null && _e !== void 0 ? _e : "");
                    AdminMiniPdfViewerState.setActiveFileId((_g = (_f = this.info) === null || _f === void 0 ? void 0 : _f.fileid) !== null && _g !== void 0 ? _g : "");
                    AdminMiniPdfViewerState.setActiveUserId(this.activeuserid);
                    PdfPageStore.activefileid = (_j = (_h = this.info) === null || _h === void 0 ? void 0 : _h.fileid) !== null && _j !== void 0 ? _j : "";
                }
                else if (res.requesttype === FileDownloadType.Download) {
                    // if (res.inqueue !== undefined && res.inqueue) {
                    //     this.setInQueue(true);
                    // } else {
                    //     this.setInQueue(false);
                    // }
                    // if (res.downloadfailed) {
                    //     this.errorDownloading(true);
                    //     this.setDownloading(false);
                    // } else if (res.downloadpath !== undefined) {
                    //     this.setDownloading(false);
                    // } else if (res.progress !== undefined) {
                    //     this.setDownloadProgress(res.progress);
                    // }
                }
                this.setLoading(false);
            }
        });
        this.versionState.versionaddedcb = (vdetails) => {
            var _a;
            this.setTitle(vdetails.name);
            this.setDownloadable(vdetails.isDownloadable);
            (_a = this.versionaddedcb) === null || _a === void 0 ? void 0 : _a.call(this, vdetails);
        };
        // this.replaceState.replaceaddcb = (rdetails) => {
        //     this.setTitle(rdetails.name);
        //     this.setDownloadable(rdetails.isDownloadable);
        //     this.replacecb?.(rdetails);
        // }
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            this.reset();
        });
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    setShowComments(show) {
        this.showcomments = show;
    }
    setShowKeywords(show) {
        this.showkeywords = show;
    }
    setShowSummary(show) {
        this.showsummary = show;
    }
    setHasSummary(sum) {
        this.hassummary = sum;
    }
    setQueued(sum) {
        this.queued = sum;
    }
    setHasKeyword(key) {
        this.haskeyword = key;
    }
    setInQueue(inqueue) {
        this.inqueue = inqueue;
    }
    setActiveDocumentId(id) {
        this.activeDocumentId = id;
    }
    resetVirusStatus() {
        this.hasVirus = VirtuStatus.Unknown;
    }
    setHasViewerContent(has) {
        this.hasviewercontent = has;
    }
    setShowVirusTitle(svt) {
        this.showvirustitle = svt;
    }
    editDocument(folderid) {
        var _a;
        if (this.info === undefined) {
            return;
        }
        this.setCreatingDraft(true);
        // now lets create a draft here and we done!
        // lets now do this
        const req = {
            letrid: (_a = this.info) === null || _a === void 0 ? void 0 : _a.letrid,
            folderid: folderid,
            type: this.isexcel ? DraftType.XLSX : DraftType.DOCX,
            fileid: this.info.fileid,
            accesskey: this.info.accesskey,
            name: this.title
        };
        Apphandler.sendMessage("createeditdocument", req);
    }
    checkAndGetFindDict() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingKeywords(true);
        const req = {
            id: this.info.fileid,
            pagename: "finddict",
            pagenumber: -1,
            accesskey: this.info.accesskey,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminpdfpage", req);
    }
    loadExcelContent() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingExcelContent(true);
        const req = {
            id: this.info.fileid,
            pagename: "viewer",
            pagenumber: -1,
            accesskey: this.info.accesskey,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminpdfpage", req);
    }
    getVirusInfo() {
        if (this.hasVirus === VirtuStatus.Negative) {
            return "Virus found on this file";
        }
        if (this.hasVirus === VirtuStatus.Postive) {
            return "No virus found on this file";
        }
        if (this.hasVirus === VirtuStatus.Unknown) {
            return "No virus scan done on this file";
        }
    }
    setFetchingStatus(ft) {
        this.fetchingstatus = ft;
    }
    setHasVirus(vr) {
        this.hasVirus = vr;
    }
    setLoadingExcelContent(loading) {
        this.loadingexcelcontent = loading;
    }
    setIsExcel(excel) {
        this.isexcel = excel;
    }
    setViewable(vable) {
        this.isViewable = vable;
    }
    setDownloadPath(path) {
        this.downloadpath = path;
    }
    errorDownloading(error) {
        this.downloaderror = error;
    }
    setDownloadProgress(prog) {
        this.downloadProgress = prog;
    }
    setDownloadable(downloable) {
        this.isDownloadable = downloable;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setDownloading(downloading) {
        this.downloading = downloading;
    }
    setTitle(title) {
        this.title = title;
    }
    setShow(show) {
        this.show = show;
        if (!this.show) {
            this.reset(); // if hidding lets reset this..
        }
    }
    hide() {
        this.show = false;
    }
    openpath() {
    }
    setShowVersionDialog(show) {
        var _a, _b;
        this.versionState.clear();
        this.versionState.addVersions((_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : []);
        this.versionState.setOpen(show);
    }
    setShowReplaceDialog(show) {
        // this.replaceState.clear();
        // this.replaceState.addReplaces(this.info?.replace ?? []);
        // this.replaceState.activeversion = this.activereplace;
        // this.replaceState.setOpen(show);
    }
    downloadToPath(queueid) {
        if (this.info === undefined) {
            return;
        }
        // this.setDownloadProgress(0);
        // this.setDownloadPath("");
        // this.errorDownloading(false);
        // this.setDownloading(true);
        const req = {
            letrid: this.info.letrid,
            id: this.info.fileid,
            requesttype: FileDownloadType.Download,
            size: this.size,
            info: {
                name: this.title
            },
            accesskey: this.info.accesskey,
            boxid: this.info.boxid,
            savepath: "",
            downloadasset: true,
            userid: this.activeuserid,
            queueid: queueid
        };
        Apphandler.sendMessage("admindownloadfile", req);
    }
    downloadAsset(queueid) {
        if (this.info === undefined) {
            return;
        }
        // this.setInQueue(true);
        this.downloadToPath(queueid);
    }
    downloadMetadata() {
        var _a;
        if (this.loading || this.info === undefined || !this.activeuserid) {
            return;
        }
        this.setLoading(true);
        const req = {
            letrid: this.info.letrid,
            id: this.info.fileid,
            size: this.size,
            accesskey: (_a = this.info.accesskey) !== null && _a !== void 0 ? _a : "",
            requesttype: FileDownloadType.Metadata,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admindownloadfile", req);
    }
    fetchFileStatus() {
        var _a, _b, _c, _d;
        if (this.fetchingstatus) {
            return;
        }
        this.setFetchingStatus(true);
        const req = {
            id: (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) !== null && _b !== void 0 ? _b : "",
            acceskey: (_d = (_c = this.info) === null || _c === void 0 ? void 0 : _c.accesskey) !== null && _d !== void 0 ? _d : ""
        };
        Apphandler.sendMessage("fileprocessstatus", req);
    }
    toggleMenu() {
        this.setMenuState(!this.menuopen);
    }
    setMenuState(state) {
        this.menuopen = state;
    }
    setCreatingDraft(cr) {
        this.creatingdraft = cr;
    }
    setLoadingKeywords(loading) {
        this.gettingkeywords = loading;
    }
    setLoadingSummary(loading) {
        this.gettingsummary = loading;
    }
    checkAndGetSummary() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingSummary(true);
        const req = {
            id: this.info.fileid,
            pagename: "summaryfile",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    checkAndGetKeyWords() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingKeywords(true);
        const req = {
            id: this.info.fileid,
            pagename: "keyword",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    reset() {
        this.setLoading(false);
        this.setDownloading(false);
        this.info = undefined;
        this.hide();
        this.errorDownloading(false);
        this.setDownloadPath("");
        this.waitingforpath = false;
        this.setActiveDocumentId("");
        this.setLoadingExcelContent(false);
        this.setCreatingDraft(false);
        this.setIsExcel(false);
        this.setHasKeyword(false);
        this.setHasSummary(false);
        this.setShowKeywords(false);
        this.setLoadingKeywords(false);
        this.keywords = [];
        this.summary = "";
        this.setLoadingSummary(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "downloading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "isViewable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "hasVirus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "isexcel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "hasviewercontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "loadingexcelcontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "isDownloadable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "downloadProgress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "downloaderror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "downloadpath", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "fetchingstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "showvirustitle", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "loadpdfinfo", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "inqueue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "creatingdraft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "menuopen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "hassummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "haskeyword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "showsummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "showkeywords", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "gettingkeywords", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "gettingsummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "queued", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminDocumentDetailStore.prototype, "activeDocumentId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDocumentDetailStore.prototype, "shownotespanel", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setShowKeywords", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setShowSummary", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setHasSummary", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setQueued", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setHasKeyword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setInQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setActiveDocumentId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "resetVirusStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setHasViewerContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setShowVirusTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "getVirusInfo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setFetchingStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setHasVirus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setLoadingExcelContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setIsExcel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setViewable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setDownloadPath", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "errorDownloading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setDownloadProgress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setDownloadable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setDownloading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setShow", null);
__decorate([
    action // use this is just want to hide but dont want to reset
    ,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "hide", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setMenuState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setCreatingDraft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setLoadingKeywords", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "setLoadingSummary", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDocumentDetailStore.prototype, "reset", null);
